module.exports = __webpack_public_path__ + "files/ee8034af814caf6e3c97c25da4480df6.png";